import { Component } from "@angular/core";
import { DialogRef } from "../../../core/ui/dialog/dialog-ref";
import {
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
    FormsModule,
    ReactiveFormsModule,
} from "@angular/forms";
import { UIService } from "../../../core/ui/ui.service";
import { AuthService } from "../../../features/shared/auth/auth.service";
import { AuthValidators } from "../../../features/shared/auth/auth.validators";
import { ComponentBase } from "../../../core/types/base";
import { SessionService } from "../../../core/state/session.service";
import { ConstantsService } from "../../../core/constants/constants.service";
import { ElementsSharedProgressBarComponent } from "../../shared/progress-bar/elements-shared-progress-bar.component";
import { InputDirective } from "../../../core/ui/elements/input/input.directive";
import { ElementsSharedAutofocusDirective } from "../../shared/autofocus/elements-shared-autofocus.directive";
import { ElementsSharedViewPasswordDirective } from "../../shared/view-password/view-password.directive";
import { FormControlPipe } from "../../../pipes/shared/form-control.pipe";

@Component({
    selector: "bs-change-email-dialog",
    templateUrl: "elements-user-change-email-dialog.component.html",
    styleUrls: ["elements-user-change-email-dialog.component.scss"],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ElementsSharedProgressBarComponent,
        InputDirective,
        ElementsSharedAutofocusDirective,
        ElementsSharedViewPasswordDirective,
        FormControlPipe,
    ],
})
export class UserChangeEmailDialogComponent extends ComponentBase {
    public emailForm: UntypedFormGroup;
    public initiator: string;

    constructor(
        public dialogRef: DialogRef<any>,
        public formBuilder: UntypedFormBuilder,
        public authService: AuthService,
        public validators: AuthValidators,
        public session: SessionService,
        public ui: UIService,
    ) {
        super();

        this.emailForm = this.formBuilder.group({
            password: new UntypedFormControl("", Validators.required),
            email: new UntypedFormControl(
                "",
                [Validators.required, Validators.pattern(ConstantsService.RegExps["emailPattern"])],
                this.validators.validateUniqueEmail,
            ),
        });

        this.initiator = this.dialogRef.params.initiator;
    }

    close(): void {
        this.dialogRef.close();
    }

    change(data: any): void {
        this.setBusy(true);

        this.wrapObservable(
            this.authService.requestChangeEmail(data, this.dialogRef.params.initiator),
        ).subscribe(
            (result) => {
                if (result) {
                    if (result.orgs) {
                        this.session.setOrgs(result.orgs);
                    }

                    if (result.user) {
                        this.session.setUser(result.user);
                    }

                    if (result.org) {
                        this.session.setOrg(result.org);
                    }
                }

                this.ui.toast({
                    type: "success",
                    title: $localize`Request sent`,
                    message: $localize`You need to verify specified email. We've sent you en email with instructions. You'll receive it shortly.`,
                });

                this.close();
                this.setBusy();
            },
            (error) => {
                let message = error.type || "";

                if (error.type === "InvalidPasswordError") {
                    message = $localize`You have specified invalid password.`;
                } else if (error.type === "EmailIsAlreadyTakenError") {
                    message = $localize`Specified email is already taken.`;
                }

                this.ui.toast({
                    type: "error",
                    title: $localize`Request failed`,
                    message,
                });

                this.setBusy();
            },
        );
    }
}
